import moment from 'moment'
import { columnHelper } from '../../../../../iba-components/Table'

const Header = (text) => {
    return <span>{text}</span>
}

export const getColumnList = (t) => [
    columnHelper.accessor('username', {
        header: Header(`${t('clientManagement.userLName')}${t('clientManagement.userFName')}`),
        size: 300
    }),
    columnHelper.accessor('analysispermission', {
        header: Header(t('clientManagement.analysispermission')),
        cell: (props) => {
            return props.getValue() === 0
                ? t('clientManagement.analysispermissionNone') // 0 = None
                : props.getValue() === 1
                ? t('clientManagement.analysispermissionFull') // 1 = Full
                : props.getValue() === 2
                ? t('clientManagement.analysispermissionAvailable') // 2 = Available
                : t('clientManagement.analysispermissionNone')
        },
        size: 200
    }),
    columnHelper.accessor('mailaddress', {
        header: Header(t('clientManagement.mailAddress')),
        cell: (props) => {
            const latestMail = props.row.original.latestmailaddress
            const mail = props.getValue()
            return latestMail || mail
        },
        size: 400
    }),
    columnHelper.accessor('createddate', {
        header: Header(t('clientManagement.createdDate')),
        cell: (props) => (props.getValue() ? moment(props.getValue()).format('YYYY/MM/DD HH:mm:ss') : ''),
        size: 200
    }),
    columnHelper.accessor('delflg', {
        header: Header(t('clientManagement.deleteFlag')),
        cell: (props) =>
            props.getValue() === 0
                ? t('clientManagement.userManagement.active')
                : props.getValue() === 1
                ? t('clientManagement.userManagement.terminate')
                : '',
        size: 200
    })
]
